import { createFileRoute, redirect } from '@tanstack/react-router';

// A página no site antigo era 'relatorio', mas no novo é 'relatorios' (plural).
// Para manter compatibilidade com links antigos, redirecionamos para a nova página.
export const Route = createFileRoute(
  '/__authenticated/comercial/produto/relatorio',
)({
  beforeLoad: () => {
    throw redirect({
      to: '/comercial/produto/relatorios',
      search: true,
      replace: true,
    });
  },
});
